import type { Client } from "@/features/clients/types";

/** Build a multi-line Bill To block from a client's name + mailing (or home)
 * address, mirroring the legacy `add_invoice` bill-to block. Falls back to just
 * the display name when no address is on file. */
export function buildBillTo(client: Client): string {
  const useMailing = client.mailingIsDifferent && client.mailingStreet;
  const street = useMailing ? client.mailingStreet : client.homeStreet;
  const line2 = useMailing ? client.mailingLine2 : undefined;
  const city = useMailing ? client.mailingCity : client.homeCity;
  const state = useMailing ? client.mailingState : client.homeState;
  const zip = useMailing ? client.mailingZip : client.homeZip;

  const cityStateZip = [city, [state, zip].filter(Boolean).join(" ")]
    .filter((part) => part && part.trim())
    .join(", ");

  return [client.name, street, line2, cityStateZip]
    .filter((part) => part && part.trim())
    .join("\n");
}
